import PropTypes from 'prop-types'
import { Alert, Badge, List, ListItem } from 'chaoskit/src/components'
import { preToCodeBlock } from 'mdx-utils'

import TextLink from './TextLink'
import ButtonLink from './ButtonLink'
import Code from './Code'
import Image from './Image'
import Quote from './Quote'
import SlackSignUpEmbed from './SlackSignUpEmbed'
import { ExperimentCard } from './ExperimentCard'
import { Columns, Column } from './MDXColumns'
import Checklist from './Checklist'
import AWSQuoteGraphic from './AWSQuoteGraphic'
import AutoLinkHeader from './AutoLinkHeader'

const BlockQuote = ({ children, ...rest }) => (
  <Quote isContainer {...rest}>
    {children}
  </Quote>
)

BlockQuote.propTypes = {
  children: PropTypes.any,
}

const Align = ({ direction, ...rest }) => (
  <div css={{ textAlign: direction }} {...rest} />
)

Align.propTypes = {
  direction: PropTypes.oneOf(['left', 'center', 'right']).isRequired,
}

export const base = {
  blockquote: (props) => <BlockQuote {...props} />,
  img: (props) => <Image {...props} />,
  a: (props) => <TextLink {...props} />,
  ul: (props) => <List space="small" type="circles" {...props} />,
  ol: (props) => <List space="small" type="numbers" {...props} />,
  li: (props) => <ListItem {...props} />,
  h1: (props) => <AutoLinkHeader as="h1" {...props} />,
  h2: (props) => <AutoLinkHeader as="h2" {...props} />,
  h3: (props) => <AutoLinkHeader as="h3" {...props} />,
  h4: (props) => <AutoLinkHeader as="h4" {...props} />,
  h5: (props) => <AutoLinkHeader as="h5" {...props} />,
  h6: (props) => <AutoLinkHeader as="h6" {...props} />,
  pre: (preProps) => {
    const props = preToCodeBlock(preProps)
    // If there's a codeString and some props, we passed the test
    if (props) {
      return <Code {...props} />
    }
    // It's possible to have a pre without a code in it
    return <pre {...preProps} />
  },
}

export const components = {
  Alert,
  AWSQuoteGraphic,
  Badge,
  ButtonLink,
  Align,
  BlockQuote,
  Checklist,
  Columns,
  Column,
  Image,
  List,
  ListItem,
  SlackSignUpEmbed,
  ExperimentCard,
}

export const shortcodes = { ...base, ...components }
